import React, { useCallback } from 'react';
import { Button } from '@tanium/react-button';
import { useAuthenticatedApiContext } from '../api/useApiClient';
import { saveBlob } from '../utilities/downloadHelper';

interface DownloadLinkProps {
  href: string;
  name: string;
}
export const DownloadLink: React.FC<DownloadLinkProps> = ({ href, name, children }) => {
  const apiClient = useAuthenticatedApiContext();
  const onDownload = useCallback(async () => {
    const blob = await apiClient.downloadFile(href);
    saveBlob(blob, name);
  }, [href, name, apiClient]);

  return (
    <Button variant="link" onClick={onDownload} role="button">
      {children}
    </Button>
  );
};
